/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import UploadProof from '../../components/UploadProof/index.tsx';
import InputFormItem from '../../components/InputFormItem/index.tsx';
import CascaderFormItem from '../../components/CascaderFormItem/index.tsx';
import SendCode from '../../components/SendCode/index.tsx';
import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import {
    certTip,
    companyQualifyTip
} from '../../components/UploadProof/uploadTip.tsx';
import zizhi from '../../asset/img/attest/zizhi.jpg';
import yunying from '../../asset/img/attest/yunying.png';
import {recordProxy, bCat_2055_request} from '../../util';
import {initialStateErr} from './conf';

import {Button, message} from 'antd';
import './appeal.less';
const CompanyModal = (props) => {
    const {
        updateAppeal,
        appealData,
        fetchSendCode,
        fetchAppealCompany
    } = props;
    const preClick = () => {
        recordProxy('prevStep', 'click', '');
        updateAppeal({
            curStep: 1,
            ...initialStateErr
        });
        window.scrollTo(0, 0);
    };
    function onSendCodeChange ({captchaTip}) {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_captcha' : 'report-mark_captcha';
        recordProxy(
            recordType,
            'click',
            captchaTip === '获取验证码' ? '获取验证码' : '重新发送'
        );
    }
    async function verifyCheck(value, updateType) {
        if (!value) {
            updateAppeal({
                [updateType + 'Err']: '不能为空'
            });
            return false;
        }
        updateAppeal({
            [updateType + 'Err']: ''
        });
        return true;
    }
    async function verifyUploadCheck(value, updateType) {
        if (!value.length) {
            updateAppeal({
                [updateType + 'Err']: '不能为空'
            });
            return false;
        }
        if (!appealData[updateType + 'Err'].length) {
            updateAppeal({
                [updateType + 'Err']: ''
            });
            return true;
        }
    }
    async function nextClick() {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_submit' : 'report-mark_submit';
        recordProxy(
            recordType,
            appealData.phone,
            appealData.attributionType + ''
        );
        const errCompanyQualify = await verifyUploadCheck(appealData.companyQualify, 'companyQualify');
        const errCompanyName = await verifyCheck(appealData.companyName, 'companyName');
        const errCompanyAddress = await verifyCheck(appealData.companyAddress, 'companyAddress');
        const errCert = await verifyUploadCheck(appealData.cert, 'cert');
        const errEmail = await verifyCheck(appealData.email, 'email');
        const errEmailCode = await verifyCheck(appealData.emailCode, 'emailCode');
        const errIsRead = await verifyCheck(appealData.isRead, 'isRead');

        if (
            errCompanyQualify
            && errCompanyName
            && errCompanyAddress
            && errCert
            && errEmail
            && errEmailCode
            && errIsRead
        ) {
            // 企业
            let companyParam = {
                phone: appealData.phone,
                'company_qualify_id': appealData.companyQualify.map(item => item.id),
                'company_operator_id': appealData.cert.map(item => item.id),
                'appeal_type': appealData.appealType,
                name: appealData.companyName,
                province: appealData.companyAddress.split(',')[0],
                city: appealData.companyAddress.split(',')[1],
                address: '',
                email: appealData.email,
                'code': appealData.emailCode,
                label: 1, // 无此项
                'is_read': 1,
                demand: 2, // 未知字段
                'is_show': 0, // 开启多平台展示[无该功能]
                'industry': '' // 行业类型[无此项]
            };
            const fetchAppealCompanyFn = (params) => fetchAppealCompany({
                ...companyParam,
                ...params
            }).then(data => {
                if (data.code === 200) {
                    recordProxy(
                        recordType + '_success',
                        'click',
                        JSON.stringify({
                            type: '2'
                        })
                    );
                    updateAppeal({
                        curStep: 3
                    });
                    window.scrollTo(0, 0);
                } else {
                    message.error(data.message);
                }
            });
            bCat_2055_request(fetchAppealCompanyFn);
        }
    }

    return (
        <div className="person-modal">
            <UploadProof
                title="企业合作资质"
                isMsgRequired={true}
                type="companyQualify"
                maxImgLength={1}
                data={appealData}
                updateData={updateAppeal}
                tips={companyQualifyTip()}
                demoImgs={[zizhi]}
            />
            <InputFormItem
                title="企业名称"
                isMsgRequired={true}
                placeholder="系统自动识别，和企业资质保持一致"
                type="companyName"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />
            <CascaderFormItem
                title="所在地区"
                isMsgRequired={true}
                placeholder="请选择企业实际办公地址"
                type="companyAddress"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />

            <UploadProof
                title="证明材料"
                isMsgRequired={true}
                type="cert"
                maxImgLength={10}
                data={appealData}
                updateData={updateAppeal}
                tips={certTip()}
                demoImgs={[yunying]}
            />
            <InputFormItem
                title="联系邮箱"
                isMsgRequired={true}
                placeholder="请输入正确的邮箱地址用来接收审核结果"
                type="email"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />
            <SendCode
                title="邮箱验证码"
                isMsgRequired={true}
                type="emailCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.email}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>

            <AgreeProtocol
                type="isRead"
                data={appealData}
                updateData={updateAppeal} />
            <div className="btn-content">
                {!appealData.hasSearchUrl
                    && <Button
                        className="btn-step2"
                        onClick={preClick}>
                            上一步
                    </Button>
                }
                <Button
                    className="btn-step2-primary"
                    type="primary"
                    disabled={!appealData.isRead}
                    onClick={nextClick}>提交</Button>
            </div>
        </div>
    );
};

CompanyModal.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchSendCode: PropTypes.func,
    fetchAppealCompany: PropTypes.func,
};

export default withRouter(CompanyModal);
